export default "__VITE_ASSET__c3cf5eb0__"